import type { Step } from "react-joyride";

export const provinceFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂແຂວງ. ຕື່ມຊື່ 3 ພາສາ (ລາວ, ไทย, EN), ໂຊນ (ບໍ່ບັງຄັບ), ສະຖານະ ແລະ ລຳດັບ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="geo-form-nameLo"]',
    content: "ຊື່ພາສາລາວ — ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-zone"]',
    content: "ເລືອກໂຊນ (A6 Shipping) ຖ້າມີ. ບໍ່ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-enabled"]',
    content: "ເປີດສະແດງໃນ dropdown checkout/shipping ຫຼືບໍ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-form-submit"]',
    content: "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
